export interface SidebarState {
  selectedMenu: string;
}

export const initialState: SidebarState = {
  selectedMenu: '',
};
